import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.50582 13.5931C8.52421 13.6901 8.5709 13.7795 8.64 13.85L11.64 16.85C11.7352 16.9422 11.8625 16.9938 11.995 16.9938C12.1275 16.9938 12.2549 16.9422 12.35 16.85L15.35 13.85C15.4185 13.7801 15.465 13.6917 15.4837 13.5956C15.5025 13.4995 15.4926 13.4001 15.4553 13.3096C15.4181 13.2191 15.355 13.1415 15.2741 13.0865C15.1932 13.0314 15.0979 13.0014 15 13H13V3.5C13 3.36739 12.9473 3.24021 12.8536 3.14645C12.7598 3.05268 12.6326 3 12.5 3H11.5C11.3674 3 11.2402 3.05268 11.1464 3.14645C11.0527 3.24021 11 3.36739 11 3.5V13H9C8.90129 12.9994 8.80461 13.0281 8.72215 13.0823C8.6397 13.1366 8.57515 13.2141 8.53665 13.305C8.49816 13.3959 8.48743 13.4962 8.50582 13.5931ZM20.5 21H3.5C3.36739 21 3.24021 20.9473 3.14645 20.8536C3.05268 20.7598 3 20.6326 3 20.5V19.5C3 19.3674 3.05268 19.2402 3.14645 19.1464C3.24021 19.0527 3.36739 19 3.5 19H20.5C20.6326 19 20.7598 19.0527 20.8536 19.1464C20.9473 19.2402 21 19.3674 21 19.5V20.5C21 20.6326 20.9473 20.7598 20.8536 20.8536C20.7598 20.9473 20.6326 21 20.5 21Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgDownloadOutline = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgDownloadOutline;
